import DataGrid from 'components/DataGrid';
import React from 'react';

import { useBPAScanDataConfig } from './BPAScanDataGrid.config';

const BPAScanDataGrid: React.FC = () => {
  const { config, data, loading } = useBPAScanDataConfig();

  return <DataGrid config={config} data={data} loading={loading} />;
};

export default BPAScanDataGrid;
